module.exports = __webpack_public_path__ + "static/GminaKosakowo-50d1e313b7fc6b9bef97da9a6fa95120.svg";